module.exports = __webpack_public_path__ + "static/media/LOGO-03.af3ec341.png";